import { Components, Theme } from '@mui/material/styles';

export const formControlTheme: Components<Theme>['MuiFormControl'] = {
  defaultProps: {
    size: "small",
  },
};
